import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from "../store/authStore";

const ProtectedRoute = () => {

  const { token, isLoggingOut } = useAuthStore();

  if (!token) {
    if (isLoggingOut) {
        return <Navigate to="/login" replace />;
      }
    return <Navigate to="/session-expired" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
